import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './featureItem.module.css';

function FeatureItemSlide(data){
    return (
        <div className={styles.featureItemSlide}>
            <div className="slide-marker"></div>
            <div className={styles.itemSlideImageWrap}>
                <div className={styles.itemSlideIcon}>
                    <img src={data.item.itemicon.image.asset.url} alt={data.item.itemicon.image.alt} />
                </div>
                <div className={styles.itemSlideImage}>
                    <img src={data.item.itemimage.image.asset.url} alt={data.item.itemimage.image.alt} />
                </div>
            </div>
            <div className={styles.itemSlideText}>
                <h4>{data.item.itemlabel}</h4>
                <PortableText blocks={data.item.itemdesc} />
            </div>
        </div>
    );
}
    
export default FeatureItemSlide;